/* global PubSubHelper */
import { createContext, Suspense, useContext, useEffect } from "react";
import Router from "./Router";
import ProviderApp, { ThemeContext } from "./ProviderApp";

export const PubSubContext = createContext({
  PubSubHelper,
});

function App() {
  const PubSubHelper = useContext(PubSubContext);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    if (process.env.REACT_APP_ENV == "development") {
      document.cookie = "cookieForCypress=run_cypress_local; path=/; max-age=86400; SameSite=Lax";
    }
  }, []);

  return (
    <ProviderApp>
      <div
        className="App"
        style={{
          opacity: 1,
          background: `var(${theme.rootBackground})`,
          color: `var(${theme.rootTextColor})`,
        }}
      >
        <Suspense fallback={<></>}>
          <Router PubSubHelper={PubSubHelper} />
        </Suspense>
      </div>
    </ProviderApp>
  );
}

export default App;
